import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../contexts/ThemeContext';
import Icon from '../AppIcon';
import Button from './Button';

const ThemeToggle = ({ className = '', size = 'md' }) => {
  const { theme, toggleTheme, isDark } = useTheme();

  const toggleVariants = {
    light: {
      rotate: 0,
      scale: 1,
      transition: { duration: 0.3, ease: "easeInOut" }
    },
    dark: {
      rotate: 180,
      scale: 1,
      transition: { duration: 0.3, ease: "easeInOut" }
    }
  };

  const iconVariants = {
    light: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: { duration: 0.2 }
    },
    dark: {
      opacity: 0,
      scale: 0,
      rotate: 90,
      transition: { duration: 0.2 }
    }
  };

  const moonVariants = {
    light: {
      opacity: 0,
      scale: 0,
      rotate: -90,
      transition: { duration: 0.2 }
    },
    dark: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: { duration: 0.2, delay: 0.1 }
    }
  };

  return (
    <Button
      variant="ghost"
      size={size}
      onClick={toggleTheme}
      className={`relative overflow-hidden ${className}`}
      aria-label={`Switch to ${isDark ? 'light' : 'dark'} mode`}
    >
      <motion.div
        variants={toggleVariants}
        animate={isDark ? 'dark' : 'light'}
        className="relative w-5 h-5"
      >
        {/* Sun Icon */}
        <motion.div
          variants={iconVariants}
          animate={isDark ? 'dark' : 'light'}
          className="absolute inset-0 flex items-center justify-center"
        >
          <Icon name="Sun" size={20} className="text-amber-500" />
        </motion.div>
        
        {/* Moon Icon */}
        <motion.div
          variants={moonVariants}
          animate={isDark ? 'dark' : 'light'}
          className="absolute inset-0 flex items-center justify-center"
        >
          <Icon name="Moon" size={20} className="text-slate-400" />
        </motion.div>
      </motion.div>
    </Button>
  );
};

export default ThemeToggle;